import {Component, OnInit} from '@angular/core';
import {ProductListComponentService, SearchCriteria} from '@spartacus/storefront';
import {ProductSearchPage} from '@spartacus/core';
import {Observable} from 'rxjs';
import {HttpUrlEncodingCodec} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {DcpEddlSearchTrackingService} from '@app/services/analytics/EDDL/dcp-eddl-search-tracking.service';

@Component({
    selector: 'dcp-search-facet-list',
    templateUrl: './search-facet-list.component.html',
    styleUrls: ['./search-facet-list.component.scss'],
    standalone: false
})
export class SearchFacetListComponent implements OnInit {
  searchResult$: Observable<ProductSearchPage>;
  queryCodec: HttpUrlEncodingCodec;

  constructor(
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    private productListComponentService: ProductListComponentService,
    private eddlSearchTrackingService: DcpEddlSearchTrackingService
  ) {
    this.queryCodec = new HttpUrlEncodingCodec();
  }

  ngOnInit() {
    this.searchResult$ = this.productListComponentService.model$;
  }

  clearAll(): void {
    this.toggleValue('');
  }

  clearAllWithKeyboard(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.clearAll();
    }
  }

  toggleValue(query: string): void {
    query = this.queryCodec.decodeValue(query).replace(/\+/g, ' ');
    this.route({query, currentPage: 0});
  }

  toggleValueWithKeyboard(event: KeyboardEvent, query: string): void {
    if (event.key === 'Enter') {
      this.toggleValue(query);
    }
  }

  route(queryParams: SearchCriteria): void {
    this.eddlSearchTrackingService.sortFilterOrPaginationHitEvent = true;
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
    });
  }
}
